// import cssVariables from '../styles/variables.module.scss'

// export const PRIMARY_FONT = cssVariables.PRIMARY_FONT

export const themeConfig = {
  /*
    App Color Theme -
  */
  primaryColor: '#12396A',
  contrastColor: '#002149',
  semcogGreen: '#64983D',
  semcogLightGray: '#A6A6A6',
  semcogDarkGray: '#757575',
  semcogBlue1: '#12396A',
  semcogLightBlue: '#5682B8',
  primaryTextColor: '#002149',
  semcogBlack: '#262626',
  titleTextColor: '#ffffff',
  lightTextColor: '#4F4F4F', // Light grey
  textFontSize: 16,
  questionFontSize: 18,
  headerFontSize: 25,
  appTitle: '#1f4487',
  welcomeTitle: '#65c7f2',
  layerControls: {
    main: '#1f4487', // RGBA 163, 213, 95, 1
    boxShadow: '#3497fd5c'
  },
  buttonText: 'white'
}
